import { render, staticRenderFns } from "./SoundWaveViz.vue?vue&type=template&id=09b9f1a8&scoped=true"
import script from "./SoundWaveViz.vue?vue&type=script&lang=js"
export * from "./SoundWaveViz.vue?vue&type=script&lang=js"
import style0 from "./SoundWaveViz.vue?vue&type=style&index=0&id=09b9f1a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b9f1a8",
  null
  
)

export default component.exports